export type FormsAndFormatsSubMode = "documents" | "proposals" | "signTemplates" | "assetLibrary";

export const FORMS_AND_FORMATS_SUB_MODE_OPTIONS = [
  { id: "documents" as const, label: "Documents" },
  { id: "proposals" as const, label: "Proposals" },
  { id: "signTemplates" as const, label: "Sign templates" },
  { id: "assetLibrary" as const, label: "Asset library" },
] as const;

export const FORMS_FORMATS_SUB_MODE_BLURB: Record<FormsAndFormatsSubMode, string> = {
  documents:
    "Browse org documents by category, fill and export PDFs, or author new forms and templates.",
  proposals:
    "Configure proposal PDF copy, calculations, document slots, and contact overrides per product type.",
  signTemplates: "Upload contract PDFs, place signature and merge fields, and publish for Turbo Sign send.",
  assetLibrary: "Upload reusable images (logos, signatures, photos) for document blocks.",
};

export function normalizeFormsFormatsSubMode(value: string | null): FormsAndFormatsSubMode | null {
  if (value === "documents" || value === "proposals" || value === "signTemplates" || value === "assetLibrary") {
    return value;
  }
  if (value === "forms") return "documents";
  return null;
}
